export default __webpack_public_path__ + "static/firstMobile-e5f5cdcbef9867da79fbc28111040d0f.jpg";